import Heading from "../UI/Heading";
import { useContext, useState } from "react";
import { DataContext } from "../../context/data-context";
import LoadingSpinner from "../UI/LoadingSpinner";
import { addExpense } from "../../api/add";
import { AuthContext } from "../../context/auth-context";
import uploadFile from "../../util/upload-file";
import truncate from "../../util/truncate";
import { useNavigate } from "react-router-dom";

export default function AddExpense() {
  const { user } = useContext(AuthContext);
  const { vehicles, fetchExpenses } = useContext(DataContext);

  const [loading, setLoading] = useState(false);
  const [warning, setWarning] = useState(false);
  const [uploading, setUploading] = useState(false);

  const navigate = useNavigate();

  const uploadExpenseHandler = async (e) => {
    e.preventDefault();
    try {
      setLoading(true);
      setWarning(false);
      const payload = {
        vehicleId: e.target.vehicle.value,
        amount: e.target.amount.value,
        date: e.target.date.value,
        description: e.target.description.value,
      };
      if (payload.vehicleId === "") throw new Error("Please select a vehicle.");
      if (e.target.bookingId.value) {
        payload.bookingId = e.target.bookingId.value;
      }
      if (e.target.attachment.files[0]) {
        const title = `${payload.vehicleId}${payload.date}${truncate(
          payload.description,
          10
        )}`;
        const url = await uploadFile(
          `expenses/${title}`,
          e.target.attachment.files[0],
          setUploading,
        );
        payload.attachment = url;
      }

      await addExpense(user, payload);
      fetchExpenses(navigate("/expenses"));
      setLoading(false);
    } catch (err) {
      console.log(err);
      setLoading(false);
      setWarning(err.message);
    }
  };

  return (
    <div className="container">
      <Heading title="Add Expense"></Heading>
      <form
        onSubmit={uploadExpenseHandler}
        className="grid items-center grid-cols-4 gap-6 my-12 text-stone-400"
      >
        <div className="grid md:col-span-2">
          <label className="text-sm">VEHICLE:</label>
          <select className="cursor-pointer form-input" name="vehicle" required>
            <option value="">Select Vehicle</option>
            {vehicles.map((vehicle) => (
              <option value={vehicle.id} key={vehicle.id}>
                {vehicle.make +
                  " " +
                  vehicle.model +
                  " " +
                  vehicle.color +
                  " " +
                  vehicle.license}
              </option>
            ))}
          </select>
        </div>
        <div className="grid">
          <label className="text-sm">AMOUNT:</label>
          <input className="form-input" name="amount" />
        </div>
        <div className="grid">
          <label className="text-sm">DATE:</label>
          <input
            className="form-input"
            name="date"
            type="date"
            required
            placeholder="YYYY-MM-DD"
          />
        </div>
        <div className="grid md:col-span-4">
          <label className="text-sm">DESCRIPTION:</label>
          <input className="form-input" name="description" />
        </div>
        <div className="grid md:col-span-2">
          <label className="text-sm">ATTACHMENT:</label>
          <input type="file" className="form-input" name="attachment" />
        </div>
        <div className="grid">
          <label className="text-sm">TYPE:</label>
          <select className="form-input" name="type">
            <option value="wash">Wash</option>
            <option value="fuel">Fuel</option>
            <option value="maintenance">Maintenance</option>
            <option value="insurance">Insurance</option>
            <option value="tickets">Tickets</option>
            <option value="tolls">Tolls</option>
          </select>
        </div>
        <div className="grid">
          <label className="text-sm">BOOKING ID:</label>
          <input
            className="form-input"
            placeholder="Can be left blank"
            name="bookingId"
          />
        </div>

        {loading ? (
          <LoadingSpinner />
        ) : (
          <button type="submit" className="btn-primary">
            Submit
          </button>
        )}
        {warning && <p className="text-red-500">{warning}</p>}
        {uploading && (
          <p className="text-stone-400">Uploading... {uploading}%</p>
        )}
      </form>
    </div>
  );
}
